






















import Vue from "vue";
import axios from "axios";
export default Vue.extend({
  data: () => ({
    articles: [] as any,
    page: 1,
    totalPage: [] as any,
    numInOnePage: 10,
    type:""
  }),
  created() {
    console.log("subpage", this.$route.name);
    let name = this.$route.name ? this.$route.name : "news";
    if (name.startsWith("news")) {
        this.type = "news";
      } else if (name.startsWith("notice")) {
        this.type = "notice";
      } else if (name.startsWith("recommend")) {
        this.type = "recommend";
      } 
  },
  mounted: function () {
    axios
      .post(Vue.prototype.serverAddr + "/api/get-item-num", {
        collection: "article",
        need:{
          "type":this.type
        }
      })
      .then((response) => {
        console.log("get response");
        this.totalPage = Math.ceil(
          (response.data as any).num / this.numInOnePage
        );
      });
    this.getArticleList();
  },
  watch: {
    page: function (val, oldVal) {
      console.log("page" + oldVal + " to " + val);
      this.getArticleList();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  methods: {
    getArticleList() {
      console.log("type", this.type)
      axios
        .post(Vue.prototype.serverAddr + "/api/get-item-list", {
          collection: "article",
          need:{
            "type":this.type
          },
          page: this.page,
          numInOnePage: this.numInOnePage,
        })
        .then((response) => {
          console.log("get response");
          this.articles = response.data;
        });
    },
    gotoArticle: function (type: string, id: string, link: string, content:string) {
      if (link != "") {
        window.location.href = link;
      } else {
        if (type == "recommend") {
          this.$router.push({
            path: `/recommend/${id}`,
          });
          console.log(id);
        } else if (content !== ""){
          this.$router.push({
            path: `/article/${type}/${id}`,
          });
          console.log(id);
        }
      }
    },
  },
});
